import Phaser from 'phaser';
import { CONFIG } from './data.js';
import { BootScene } from './scenes/boot.js';
import { MenuScene } from './scenes/menu.js';
import { ShopScene } from './scenes/shop.js';
import { GameScene } from './scenes/game.js';
import { HUDScene } from './scenes/hud.js';
import { UpgradeScene } from './scenes/upgrade.js';
import { GameOverScene } from './scenes/gameover.js';

const config = {
  type: Phaser.AUTO,
  parent: 'game',
  width: CONFIG.width,
  height: CONFIG.height,
  backgroundColor: CONFIG.bgColor,
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    // CSS flex on #game already centers the canvas; CENTER_BOTH would
    // stack a second set of margins on top and push it off-center.
    autoCenter: Phaser.Scale.NO_CENTER,
  },
  physics: {
    default: 'arcade',
    arcade: { gravity: { x: 0, y: 0 }, debug: false },
  },
  scene: [
    BootScene,
    MenuScene,
    ShopScene,
    GameScene,
    HUDScene,
    UpgradeScene,
    GameOverScene,
  ],
};

new Phaser.Game(config);
